import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TabPanel from "components/tabPanel/tabPanel";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InnerAssetRow from 'components/customAssetRow/innerAssetRow';
import EmptyAssetRow from 'components/customAssetRow/emptyAssetRow';
import Capitalize from 'components/capitalize/capitalize';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import AssetIcon from 'components/icons/assetIcon';
import InfoIcon from "components/icons/infoIcon"
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TimerIcon from '@material-ui/icons/Timer';
import PowerOffIcon from '@material-ui/icons/PowerOff';
import Chip from '@material-ui/core/Chip';
import customAssetRowStyle from 'assets/jss/components/customAssetRowBig';

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

/* CUSTOM TABLECELL */
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgba(51, 51, 51, 1)",
        color: theme.palette.common.white,
    }
}))(TableCell);

/* CUSTOM TABS */
const StyledTabs = withStyles((theme) => ({
    indicator: {
        direction: "ltr",
        right: "0",
        width: "10px",
        backgroundColor: theme.palette.primary.main,
    },
}))((props) => <Tabs {...props} />);

/* CUSTOM TAB */
const StyledTab = withStyles((theme) => ({
    wrapper: {
        alignItems: "flex-start"
    },
    selected: {
        color: theme.palette.primary.main
    }
}))((props) => <Tab {...props} />);

export default function CustomAssetRowBig(props) {
    const { t } = useTranslation();

    const { rows, showAvailable, ...rest } = props;

    const classes = customAssetRowStyle();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const countAssets = (type) => {
        var count = 0;
        rows.filter((el) => {
            return el.type === type;
        }).forEach(row => {
            row.assets.forEach(asset => {
                if (asset.equipmentInUse === !showAvailable)
                    count++;
            });
        });
        return count;
    };

    return (
        <div {...rest} className={classes.root}>
            <StyledTabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
            >
                {rows.map((elem, key) => (
                    <StyledTab
                        className={classes.verticalTabs}
                        label={<div className={classes.flexTabRow}> <AssetIcon assetType={elem.type} /> <strong className={classes.flexTabRowInner}>{t(elem.type)} ({countAssets(elem.type)}) </strong></div>}
                        {...a11yProps(elem.type)}
                        key={elem.type} />
                ))}
            </StyledTabs>
            {rows.map((elem, key) => (
                <TabPanel value={value} index={key} key={elem.type} className={classes.innerTabPanel}>
                    <Table size="small" aria-label="features">
                        <TableHead>
                            {elem.assets.filter((item) => {
                                var currVal = item.equipmentInUse === undefined ? true : item.equipmentInUse;
                                return !currVal === showAvailable;
                            }).length > 0 ? (
                                    <TableRow className={classes.headerRow}>
                                        <StyledTableCell colSpan={2} className={classes.leftAlign}>
                                            <Capitalize transform={'sentenceCase'}>{t('console')}</Capitalize>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.rightAlign}>
                                            <Capitalize transform={'sentenceCase'}>{t('features')}</Capitalize>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.rightAlign}>
                                            <span className={classes.statusSpan}>
                                                <Capitalize transform={'sentenceCase'}>{t('status')}</Capitalize>
                                            </span>
                                            <Tooltip
                                                id="instagram-tooltip"
                                                title={
                                                    <React.Fragment>
                                                        <Chip icon={<TimerIcon />} label={'12:34'} color="primary" className={classes.customChip} />
                                                        <Typography color="inherit">{t('statusTime')}</Typography>
                                                        <Chip icon={<PowerOffIcon />} label={"Not Connected"} color="primary" className={classes.customChip} />
                                                        <Typography color="inherit">{t('statusNotConnected')}</Typography>
                                                    </React.Fragment>
                                                }
                                                placement={"bottom"}
                                                classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                                                arrow
                                            >
                                                <Button color="primary" className={classes.buttonTooltip}>
                                                    <InfoIcon className={classes.buttonColor} />
                                                </Button>
                                            </Tooltip>
                                        </StyledTableCell>
                                    </TableRow>
                                )
                                :
                                null
                            }
                        </TableHead>
                        <TableBody>
                            {elem.assets.filter((item) => {
                                var currVal = item.equipmentInUse === undefined ? true : item.equipmentInUse;
                                return !currVal === showAvailable;
                            }).length > 0 ? elem.assets.filter((item) => {
                                var currVal = item.equipmentInUse === undefined ? true : item.equipmentInUse;
                                return !currVal === showAvailable;
                            }).sort((a, b) => {
                                var firstVal = a.equipmentInUse === undefined ? false : a.equipmentInUse;
                                var secondVal = b.equipmentInUse === undefined ? false : b.equipmentInUse;
                                return secondVal - firstVal;
                            }).map((innerElem) => (
                                <InnerAssetRow showAvailable={showAvailable} asset={innerElem} key={innerElem.bodySerial} />
                            ))
                                :
                                <EmptyAssetRow />
                            }
                        </TableBody>
                    </Table>
                </TabPanel>
            ))
            }
        </div>
    );
}

CustomAssetRowBig.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
    showAvailable: PropTypes.bool.isRequired,
};